// extracted by mini-css-extract-plugin
module.exports = {"chainTag":"style_chainTag__3Pa9p","noChain":"style_noChain__LBBTE"};